export default "__VITE_ASSET__ChvWnptZ__"